export default "__VITE_ASSET__9b8a8ea3__"